import { Button } from '@shared/components/ui/button';
import { Input } from '@shared/components/ui/input';
import { ModalCenter } from '@shared/components/ui/ModalCenter';
import { forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { useEditPrinterModal } from '../../hooks/useEditPrinterModal';

// Tipos definidos inline
export interface EditPrinterModalRef {
  open: (printer: { id: number; code?: string; name: string; type: string; custom_name?: string | null }) => void;
}

interface Props {
  onUpdated?: () => void;
}

export const EditPrinterModal = forwardRef<EditPrinterModalRef, Props>(({ onUpdated }, ref) => {
  const { t } = useTranslation('printersModule');
  const { modalRef, openModal, closeModal, handleSave, name, setName, fallbackName, isLoading } =
    useEditPrinterModal(onUpdated);

  useImperativeHandle(ref, () => ({ open: openModal }));

  return (
    <ModalCenter
      ref={modalRef}
      title={t('modal.edit.title')}
      type="default"
      width="lg"
      className="h-[calc(100%-30px)] sm:h-auto"
    >
      <div className="space-y-4 flex flex-col justify-between h-full">
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-text">{t('modal.edit.name_label')}</label>
            <Input
              className="mt-1"
              placeholder={fallbackName}
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={isLoading}
              autoFocus
              data-testid="edit-printer-name-input"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-4">
          <Button variant="outline" onClick={closeModal} name="cancel" size="lg" disabled={isLoading}>
            {t('button.cancel')}
          </Button>
          <Button variant="primary" onClick={handleSave} name="confirm" size="lg" disabled={isLoading}>
            {isLoading ? t('button.saving') : t('button.save')}
          </Button>
        </div>
      </div>
    </ModalCenter>
  );
});

EditPrinterModal.displayName = 'EditPrinterModal';
